'use strict';

const { param } = require('jquery');

angular.module('schoolLinqApp').directive('taxParameterDisplay', taxParameterDisplayController);

function taxParameterDisplayController() {
	var controller = [
		'$scope',
		'$q',
		'employeeTaxService',
		'BUSY_MESSAGE',
		function (scope, $q, employeeTaxService, BUSY_MESSAGE) {
			scope.loadTaxParameters = function () {
				scope.fields = [];
				scope.groups = [];
				scope.editing = false;

				scope.busyMessage = BUSY_MESSAGE.Loading;
				scope.busyPromise = employeeTaxService.getCurrentEmployeeW4(scope.employeeId).then(finishedGettingTaxParameters);

				function finishedGettingTaxParameters(response) {
					if (response.data.isValid) {
						scope.fields = response.data.results;
						scope.fieldsBackup = angular.copy(scope.fields);
						scope.groups = scope.getGroups();

						_.forEach(scope.fields, function (field) {
							if (field.ParameterName === 'FILINGSTATUS') {
								scope.setFriendlyFilingStatus(field);
							}
						});
					} else {
						scope.errors.push(response.data.error);
					}

					if (scope.mustReload === true) {
						scope.mustReload = false;
						scope.afterSave();
					}
				}
			};
			scope.setFriendlyFilingStatus = function (filingStatusParameter) {
				let value = _.find(filingStatusParameter.ListValuesList, function (valueDescription) {
					return valueDescription.Value === filingStatusParameter.ParameterValue;
				});

				if (value != null) {
					filingStatusParameter.ParameterValue = value.Description;
				}
			};

			scope.getGroups = function () {
				let groupNames = _.uniq(
					_.map(scope.fields, function (field) {
						return field.TaxDescription;
					})
				);

				let groups = [];
				_.forEach(groupNames, function (groupName) {
					let groupFields = scope.getGroupFields(groupName);
					groups.push({
						groupName: groupName,
						groupFields: groupFields,
						updatingName: false,
					});
				});

				return groups;
			};

			scope.getGroupFields = function (groupName) {
				let groupFields = _.filter(scope.fields, function (field) {
					return field.TaxDescription === groupName;
				});
				return groupFields;
			};

			scope.isEdit = function () {
				if (employeeTaxService.dirty && !employeeTaxService.editing) {
					employeeTaxService.dirty = false;
					scope.loadTaxParameters();
				}
				return employeeTaxService.editing;
			};
			scope.doEdit = function () {
				scope.editing = true;
				employeeTaxService.editing = true;
			};
		},
	];

	return {
		restrict: 'E',
		scope: {
			employeeId: '=', // integer Id of the employee
			busyPromise: '=', // reference to calling page
			busyMessage: '=', // reference to calling page
			okToLoad: '=', // flag to enable/disable loading of data
			readonly: '=', // flag indicating read-only status
		},
		template: require('@ajs/templates/taxParametersDisplay.html'),
		controller: controller,
		link: function (scope, element, attrs) {
			scope.$watch('okToLoad', function (value) {
				if (value === true && scope.employeeId) scope.loadTaxParameters();
			});

			scope.$watch('doCancel', function (value) {
				if (value === true) {
					scope.doCancel = false;
					scope.cancelChanges();
				}
			});
		},
	};
}
